<template>
  <section>
    <div class="container">
      <div class="faq-container">
        <HealthInsuranceQuestion
          v-for="(question, index) in questions"
          :key="question.question + index"
          :index="index"
          :question="question.question"
          :answer="question.answer"
          :divider="index !== questions.length - 1"
        />
      </div>
    </div>
  </section>
</template>

<script>
import HealthInsuranceQuestion from "~/components/healthInsurance/HealthInsuranceQuestion.vue"
import HealthInsurances from "~/models/healthInsurances.js"

export default {
  name: "AokPlusQuestionsSection",
  components: { HealthInsuranceQuestion },
  props: {
    healthInsurance: {
      type: String,
      default: HealthInsurances.aokPlus,
    },
  },
  computed: {
    questions: function () {
      const allFaqs = [
        {
          question: "costsQuestionMobil",
          answer: "costsAnswerMobil",
          showForHealthInsurances: [HealthInsurances.mobil],
        },
        {
          question: "whatIsIt",
          answer: "whatIsItAnswer",
          showForHealthInsurances: [HealthInsurances.mobil, HealthInsurances.aokPlus, HealthInsurances.aokRps],
        },
        {
          question: "recommendationQuestion",
          answer: "recommendationAnswer",
          showForHealthInsurances: [HealthInsurances.aokRps],
        },
        {
          question: "formularQuestion",
          answer: "formularAnswer",
          showForHealthInsurances: [HealthInsurances.aokRps],
        },
        {
          question: "problemsQuestion",
          answer: "problemsAnswer",
          showForHealthInsurances: [HealthInsurances.mobil, HealthInsurances.aokPlus, HealthInsurances.aokRps],
        },
      ]
      return allFaqs.filter(faq => faq.showForHealthInsurances.includes(this.healthInsurance))
    },
  },
}
</script>

<style scoped lang="scss">
.faq-container {
  margin: 0 auto;

  @media (max-width: $desktop) {
    padding: 0 1rem;
  }
}
</style>
